import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Title, description and language for a public page; restored on leaving so the
// logged-in app keeps its own title.
export const usePageMeta = ({ title, description }) => {
	useEffect(() => {
		const prevTitle = document.title;
		const prevLang = document.documentElement.lang;
		let meta = document.querySelector('meta[name="description"]');
		const created = !meta;
		if (created) {
			meta = document.createElement('meta');
			meta.name = 'description';
			document.head.appendChild(meta);
		}
		const prevDescription = meta.content;

		document.title = title;
		document.documentElement.lang = 'el';
		meta.content = description;

		return () => {
			document.title = prevTitle;
			document.documentElement.lang = prevLang;
			if (created) meta.remove();
			else meta.content = prevDescription;
		};
	}, [title, description]);
};

// Scroll to the section named in the URL (e.g. /#lyseis from another page).
export const useHashScroll = () => {
	const { hash } = useLocation();
	useEffect(() => {
		if (!hash) {
			window.scrollTo(0, 0);
			return;
		}
		const el = document.getElementById(hash.slice(1));
		if (el) requestAnimationFrame(() => el.scrollIntoView({ block: 'start' }));
	}, [hash]);
};
